import React from "react";
import { SvgV2 } from "@whatslly/ui-components/v2/BaseElements/SvgV2";
import styles from "./questionMarkIcon.module.scss";

export const QuestionMarkIcon: React.FC = React.memo(() => {
  return (
    <div className={styles.icon}>
      <SvgV2 iconName={"question-mark"} />
    </div>
  );
});
